import { DEFAULT_LOCALE, type Locale } from "@i18n/react";
import type { ComponentProps, JSX } from "react";

import type { Cookies } from "./types";
import { getFramework } from "./utils";

const framework = getFramework();

export let getCookies: () => Promise<Cookies>;
if (framework === "next") getCookies = require("next/headers").cookies;
/** TODO */ else
  getCookies = async () => ({
    get: () => ({ name: "", value: "" }),
    set: () => {},
    delete: () => {},
  });

export let getLocale: (request?: Request) => Locale | Promise<Locale>;
if (framework === "next") getLocale = require("@i18n/next/server").getLocale;
else if (framework === "rr")
  import("@i18n/rr").then(({ getLocale: getLocaleRr }) => {
    getLocale = getLocaleRr;
  });
else getLocale = () => DEFAULT_LOCALE;

export type ImageProps = Omit<ComponentProps<"img">, "src"> & {
  fill?: boolean;
  objectFit?: "cover";
  placeholder?: "blur";
  src:
    | string
    | {
        src: string;
        height: number;
        width: number;
        blurDataURL?: string;
        blurWidth?: number;
        blurHeight?: number;
      };
};
export let Image: (props: ImageProps) => JSX.Element;
if (framework === "next") Image = require("next/image").default;
else
  Image = ({ fill, objectFit, placeholder, src, ...props }: ImageProps) => (
    <img src={typeof src === "string" ? src : src.src} {...props} />
  );

type LinkProps = ComponentProps<"a">;
export let Link: (props: LinkProps) => JSX.Element;
if (framework === "next") Link = require("@i18n/next").Link;
else if (framework === "rr")
  import("@i18n/rr").then(({ Link: LinkRr }) => {
    Link = LinkRr;
  });
else Link = ({ children, ...props }: LinkProps) => <a {...props}>{children}</a>;

type ScriptProps = {
  src: string;
  strategy?: "lazyOnload";
  onLoad?: () => void;
};
export let Script: (props: ScriptProps) => JSX.Element | null;
if (framework === "next") Script = require("next/script").default;
else Script = () => null;
